import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { Authority } from '../model/authority.model';
import { SessionQuery } from '../state/session.query';

@Injectable({ providedIn: 'root' })
export class UserRouteAdminAccessService  {
  constructor(private router: Router, private sessionQuery: SessionQuery) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const currentUser = this.sessionQuery.getValue().user;

    // eslint-disable-next-line no-console
    console.log(route.url.map(sUrl => sUrl.path));

    if(currentUser) {
        if(this.sessionQuery.hasAnyAuthority(Authority.ROLE_ADMIN)) {
            return this.router.createUrlTree(['/', 'admin', ...route.url.map(sUrl => sUrl.path)]);
        }
        return true;
    }

    return this.router.createUrlTree(['/']);
  }
}
